export default () => ({
  conversations: null,
  activeConversation: null,
  messages: null,
  hasData: false,
  unseenMessages: null,
  total: null,
});
